import gql from 'graphql-tag';

const updateRulesMutation = gql`
  mutation UpdateRules($input: UpdateRulesInput!) {
    updateRules(input: $input) {
      success
    }
  }
`;

export default updateRulesMutation;
